export default __webpack_public_path__ + "a272c960b38747e11446379c1debfd19.png";